import React, { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { t } from 'i18next'

import useConfirmationModal from '~/hooks/useConfirmationModal'
import { deleteProductOnCampaign } from '~/modules/retailMedia/store/campaign/actions'

import ProductContent from './Content'

/**
 * Componente responsável por renderizar um produto nas listagens.
 * @param {Object} data Dados do produto
 * @param {boolean} isSelected Informa se o produto está na lista dos selecionados
 * @param {string[]} selectedSKUS Informa os SKUS selecionados para mudarmos o botão no painel de busca
 * @param {boolean} hasAction Informa se o produto está numa página de edição e deve exibir botões de ação
 */
const Product: React.FC<ProductProps> = ({
  data,
  isSelected = false,
  selectedSKUS = null,
  selectedIDs = null,
  hasAction = false,
  itemsDisableds = null,
  subPublisherIds,
  allSubpublishers,
  campaignType
}) => {
  const dispatch = useDispatch()

  // Modal
  const [Modal, isModalOpen, toggleModal, setIsModalOpen] =
    useConfirmationModal()

  const shouldConfirmDelete = useMemo(() => data.isSuggested, [data])

  const handleDeleteProduct = useCallback(() => {
    dispatch(deleteProductOnCampaign({ product: data }))
    setIsModalOpen(false)
  }, [data, dispatch, setIsModalOpen])

  return (
    <>
      <ProductContent
        data={data}
        isSelected={isSelected}
        selectedSKUS={selectedSKUS}
        selectedIDs={selectedIDs}
        hasAction={hasAction}
        itemsDisableds={itemsDisableds}
        handleDeleteProduct={handleDeleteProduct}
        setIsModalOpen={setIsModalOpen}
        shouldConfirmDelete={shouldConfirmDelete}
        subPublisherIds={subPublisherIds}
        allSubpublishers={allSubpublishers}
        campaignType={campaignType}
      />

      {shouldConfirmDelete && (
        <Modal
          title={t(
            'rm:objectiveBased.AutomaticallySelectedProducts.dialog.title'
          )}
          showContentTitle={false}
          isOpen={isModalOpen}
          onClose={toggleModal}
          onSubmit={handleDeleteProduct}
          cancelButton={t('rm:button.Cancel')}
          confirmationButton={t(
            'rm:objectiveBased.AutomaticallySelectedProducts.dialog.button'
          )}
          prepend={
            <ProductContent
              data={data}
              isSelected={isSelected}
              selectedSKUS={selectedSKUS}
              selectedIDs={selectedIDs}
              itemsDisableds={itemsDisableds}
              allSubpublishers={allSubpublishers}
              className="mb-3 p-2 border border-danger rounded"
              campaignType={campaignType}
            />
          }
        >
          {t('rm:objectiveBased.AutomaticallySelectedProducts.dialog.alert')}
        </Modal>
      )}
    </>
  )
}

export default Product
